function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.267.435l.44.44a1 1 0 01.293.707v.507a1 1 0 01-.293.72l-1.234 1.213a.333.333 0 01-.473 0l-1.873-1.9a.333.333 0 010-.467l1.207-1.22a1 1 0 01.72-.293h.506a1 1 0 01.707.293zm-2.06 4.84a.333.333 0 000-.466L8.3 2.929a.333.333 0 00-.473 0l-5.38 5.38c-.13.129-.232.283-.3.453L1 11.655a.333.333 0 00.127.414.333.333 0 00.36.073l2.893-1.173c.17-.068.325-.17.453-.3l5.374-5.394z"
});

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgEdit;